import { useEffect, useState } from "react";
import { UserRound } from "lucide-react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

const cache = new Map();

export const loadBlobUrl = (path, stamp) => {
  const key = `${path}?${stamp}`;
  if (!cache.has(key)) {
    const p = api.get(path, { responseType: "blob", params: { v: stamp } }).then((r) => URL.createObjectURL(r.data));
    p.catch(() => cache.delete(key));
    cache.set(key, p);
  }
  return cache.get(key);
};

export function useAvatarUrls(people) {
  const [urls, setUrls] = useState({});
  const sig = people.filter((p) => p.id && p.stamp).map((p) => `${p.id}:${p.stamp}`).sort().join("|");
  useEffect(() => {
    let live = true;
    const list = sig ? sig.split("|").map((s) => s.split(":")) : [];
    Promise.all(list.map(([id, ...rest]) => loadBlobUrl(`/users/${id}/avatar`, rest.join(":")).then((u) => [id, u]).catch(() => null)))
      .then((pairs) => live && setUrls(Object.fromEntries(pairs.filter(Boolean))));
    return () => {
      live = false;
    };
  }, [sig]);
  return urls;
}

export function useBlobUrl(path, stamp) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!stamp) {
      setUrl(null);
      return undefined;
    }
    let live = true;
    loadBlobUrl(path, stamp).then((u) => live && setUrl(u)).catch(() => live && setUrl(null));
    return () => {
      live = false;
    };
  }, [path, stamp]);
  return url;
}

export const UserAvatar = ({ userId, stamp, name, className = "h-8 w-8", testId }) => {
  const url = useBlobUrl(`/users/${userId}/avatar`, userId && stamp);
  return (
    <span className={cn("flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-slate-800 text-slate-300", className)} data-testid={testId}>
      {url ? <img src={url} alt={name || "Profile picture"} className="h-full w-full object-cover" /> : <UserRound className="h-1/2 w-1/2" />}
    </span>
  );
};
